import ScrollPage from "@/components/ScrollPage";
import { PageHeader } from "@/components/Headers";
import AccountBalance from "./AccountBalance";
import ContactInfo from "./ContactInfo";
import CollectionVolumes from "./CollectionVolumes";
import CustomerGreeting from "./CustomerGreeting";

export default function OverviewPage() {
    return (
        <ScrollPage>
            <PageHeader>Account Overview</PageHeader>
            <div className="space-y-4">
                <CustomerGreeting />
                <AccountBalance />
                <ContactInfo />
                <CollectionVolumes />
            </div>
        </ScrollPage>
    );
}